import ReactPlayer from "react-player-v3";

export const VideoViewer = ({
  mediaURL,
  isMediaOpen,
}: { mediaURL?: string; isMediaOpen: boolean }) => {
  if (!isMediaOpen || !mediaURL) return null;

  return (
    <ReactPlayer
      src={mediaURL}
      autoPlay
      playsInline
      width="100%"
      height="100%"
      onClick={(e: React.MouseEvent<HTMLVideoElement>) => e.stopPropagation()}
      loop
      controls
      className="object-contain absolute inset-0 size-full"
    />
  );
};
